import React from 'react';
import code from '@/public/assets/code.png';
import code2x from '@/public/assets/code@2x.png';
import code3x from '@/public/assets/code@3x.png';
import ImgIcon from '../BaseIcon';

const Code = () => (
    <ImgIcon
        srcset={`${code},
                ${code2x} 2x,
                ${code3x} 3x,`}
        src={code3x}
        alt="code"
    />
);

export default Code;
